var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServefooterVisual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.414,
    height: 52.893,
    viewBox: "0 0 59.414 52.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_177",
    "data-name": "\\uD328\\uC2A4 177",
    d: "M918.422,550.765c-2.7-2.7-7.238-3.064-12.447-1.476a9.25,9.25,0,0,0-2.419-6.869c-5.571-5.571-18.976-1.2-29.94,9.767s-15.338,24.369-9.767,29.94c2.7,2.7,7.239,3.065,12.448,1.476a9.253,9.253,0,0,0,2.418,6.869c5.571,5.571,18.976,1.2,29.941-9.766S923.993,556.336,918.422,550.765Z",
    transform: "translate(-861.429 -540)",
    fill: "#ecdf19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServefooterVisual);
export default __webpack_public_path__ + "static/media/servefooter_visual.0050b8822e5f90dccc021202a9df4148.svg";
export { ForwardRef as ReactComponent };